module.exports = __webpack_public_path__ + "assets/auth-top-left.a3ff35c6.svg";